// 全局分享按钮
export function shareFn() {
    var oL, oT
    var shareBox = document.querySelector('#shareBox');
    //限制最大宽高，不让滑块出去
    var maxW = document.body.clientWidth - shareBox.offsetWidth;
    var maxH = document.body.clientHeight - shareBox.offsetHeight;
    //手指触摸开始，记录div的初始位置
    shareBox.addEventListener('touchstart', function (e) {
        var ev = e || window.event;
        var touch = ev.targetTouches[0];
        oL = touch.clientX - shareBox.offsetLeft;
        oT = touch.clientY - shareBox.offsetTop;
        document.addEventListener("touchmove", defaultEvent, { passive: false });
    });

    //触摸中的，位置记录
    shareBox.addEventListener('touchmove', function (e) {
        var ev = e || window.event;
        var touch = ev.targetTouches[0];
        var oLeft = touch.clientX - oL;
        var oTop = touch.clientY - oT;
        if (oLeft < 0) {
            oLeft = 0;
        } else if (oLeft >= maxW) {
            oLeft = maxW; 
        }
        if (oTop < 0) {
            oTop = 0;
        } else if (oTop >= maxH) {
            oTop = maxH;
        }
        shareBox.style.left = oLeft + 'px';
        shareBox.style.top = oTop + 'px';
    });

    //触摸结束时的处理
    shareBox.addEventListener('touchend', function () {
        document.removeEventListener("touchmove", defaultEvent);
        var limit = parseInt(document.body.clientWidth / 2) - shareBox.offsetLeft;
        if (limit > 30) {
            shareBox.style.left = 10 + 'px';
        } else {
            shareBox.style.left = maxW - 10 + 'px';
        }
    });

    //阻止默认事件
    function defaultEvent(e) {
        e.preventDefault();
    }

    // 点击按钮时的处理
    shareBox.onclick = function () {
        // var obj = new Object();
        //     obj.title="慧联天下";
        //     obj.descr="综合服务平台";
        //     obj.shareUrl="https://www.dtb315.com/home/index/main";
        //     dtb.iPhoneShare(JSON.stringify(obj));
        // var el = document.getElementsByClassName('fenxiang1')[0];
        // el && el.click();
    }
}
setTimeout(function () {
    shareFn();
}, 2000)